import styled from 'styled-components';

import {
  whiteSphera,
  greenSp,
  brandBlack,
  grayMediumSphera,
  graySphera
} from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalCampaignSuccess = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showFinishedModal ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  z-index: 200;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.6);
  animation: ${(props) => (props.showFinishedModal ? fadeIn : fadeOut)} 0.5s linear;
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  max-width: 800px;
  border-radius: 5px;
  background-color: ${whiteSphera};
  padding: 3%;
  > h2 {
    font-size: 2.2vw;
    text-align: center;
    color: ${brandBlack};
    > span {
      color: ${greenSp};
      font-size: 2.2vw;
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const InfoContainer = styled.section`
  margin-top: 10%;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  h3 {
    width: 100%;
    color: ${graySphera};
    font-size: 1.5vw;
    margin-bottom: 5px;
    > a {
      color: ${greenSp};
      font-weight: bold;
      font-size: 1.8vw;
    }
  }
`;

export const CloseButton = styled.button`
  color: ${whiteSphera};
  font-size: 1.2vw;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  width: 40%;
  margin: 5% 0;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: ${brandBlack};
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    transform: scale(1.1);
  }
`;
